/**
 * created by tian ruo jun
 * 2022/04/15
 * 稿件编辑器
 * 用于打开1.1版本稿件，区别于StoryEditor：右侧没有投稿至模块设置。
 * 主要用于打开微信主媒体投稿稿件生成的1.1版本稿件，
 * 因此类稿件不需要创建1.1.1版本（即网站稿件），所以在投递至素材中心或被编辑打回给写稿人时，这篇稿件一直处于1.1版本状态
 */
import React from 'react';
import {Input, message} from "antd";
import Editor from '../Editor'
import {base64Encode} from "../../../utils";
import StoryEditor from '../storyEditor/StoryEditor';
import {removeContentSecurity} from "../floatTool/securityCheck";
import {getInfoFromLocalStorage} from "../../../actions";
import SyncModal from "../../components/syncModal/syncModal";
import ButtonList from "../components/activitiAndBtn/ButtonList";
import LinkCheck from "../components/pluginsSpace/linkCheck/linkCheck";
import {systemBaseEvent} from "../../../base/baseEvent";
const {TextArea} = Input;

export default class ReceiveEditor extends StoryEditor {
    static defaultProps = {};
    static propTypes = {};

    activitiBtns;

    componentWillMount() {
        let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
        let urlParams = this.urlParams;
        if(!id && !(urlParams && urlParams.storyId)) {
            this.initActivitiConfig({});
        }
        //接收参数去渲染数据
        this.initParentData();
    }

    /**设置流程配置*/
    async initActivitiConfig(story) {
        let id = (this.props.id && this.props.id.length > 1) ? this.props.id : '';
        let that = this;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";

        // 判断操作权限start
        let showBtnFlag = false;
        let mediaId = story && story.mediaId ? story.mediaId : "";
        if(mediaId) {
            let menu = getInfoFromLocalStorage("menu");
            let publishMenu = menu.find(item=>item.menuCode == "mediaPublish");
            if(publishMenu && publishMenu.child && publishMenu.child.length) {
                if(publishMenu.child.find(item=>item.menuCode == mediaId)) {
                    showBtnFlag = true;
                }
            }
        } else {
            showBtnFlag = true;
        }
        // 判断操作权限end
        let pojoName = 'tggj';
        if(this.urlParams && this.urlParams.activitiConfName && this.urlParams.activitiConfName.indexOf("sczxwxlc")>-1) {
            pojoName = 'likeWechat'
        }
        // 判定微信投稿稿件是否拼接旧审核流start
        // 没有查到审核流记录的判定为新的微信审核流稿件，此时需要用旧id重启流程
        let hasActHistory = await this.getActHistoryLength(id);
        let againFlag = false;
        if(!hasActHistory) {
            // 如果需要拼接审核流，则在重启审核流时需要传旧审核流id
            let oldId = await this.findOldUuid({id});
            if(oldId) {
                againFlag = true;
                id = oldId;
            }
        }
        // 判定微信投稿稿件是否拼接旧审核流end
        this.state.activityOption = {
            ...this.state.activityOption,
            id: id,//流程id
            activitiConf: this.urlParams ? {type: this.urlParams.activitiConfName} : null,//流程conf
            pojoName: pojoName,//数据表name
            userAccount: account,//当前用户account
            showBtnFlag:true,//是否显示流程按钮
            againFlag,//重置流程的判断条件
            showAfterFuns: {
                /**
                 * 是否显示撤回按钮
                 */
                callBackBtnShow: (item, call) => {
                    // 点击素材中心稿件标题进入的稿件
                    if (that.urlParams && that.urlParams.operateType && that.urlParams.operateType === "contribute") {
                        let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.goBack.states", "已返回写稿人,返回写稿人,返回修改");
                        // 稿件状态为返回写稿人
                        if (story && story.statusName && activitiConfName.includes(story.statusName)) {
                            call({code: 0, log: "不显示撤回按钮！"});
                            return
                        }
                    }
                    call({code: 1});
                },
            },//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                setSourceUser: (activiti, buttonConf, call) => {
                        let myId = (window.currentUser && window.currentUser.account) ? window.currentUser.id : "";
                        if(myId === this.storyData.submitter) {
                            message.warning("当前稿件写稿人与当前操作人是同一人，无需返回");
                            window.loading.hide();
                            return false
                        }
                        activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                            id:this.storyData.submitter,
                            name:this.storyData.submitterName
                        }];
                        call({code:1,log:"查询到返回者为：" + this.storyData.creator});
                },
            },//流程按钮点击事件前置js
            saveFunction: that.saveStory,//稿件保存方法
            saveStatusNameFunction: that.updateStatusName,//稿件改流程状态方法
            onSubmitOK: function (activiti) {
                that.refresh(activiti)
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            showRemarks: (remarks) => {
                if(remarks && remarks.length) {
                    this.setState({showRemarks:true,remarks})
                }
            },//备注回显
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            mustNotShowPublishBtn: true, // 投稿编辑器中永远不显示发布按钮
            btnLoadOver:(btns)=>{
                this.activitiBtns = btns;
                this.setState({});
            },
            showBtnIcon: true,
            showLockCall: (data) => {
                // data={status: true, id: this.messageId}  true 加锁成功，只有当前人可编辑，  false 加锁失败，不可编辑，
                // 如果加锁失败，则开启遮罩
                if (!data.status) {
                    this.Editor.showLockMask(data);
                    this.state.isLockedData = data;
                    this.setState({})
                }
            },
            btnType: "editor",
            checkForm: that.checkForm
        };
        this.setState({});
    }
    //渲染流程按钮
    renderActBtn = () => {
        let buttonListData = this.getActBtnListData();
        let isLockedData = {isLockedData: this.state.isLockedData ? this.state.isLockedData : {}};
        return (
            buttonListData ?
                <>
                    <ButtonList {...buttonListData}{...isLockedData}/>
                    <SyncModal ref={ref => this.syncModal = ref}/>
                    <LinkCheck ref={ref=>this.LinkCheck=ref}/>
                </> : <></>
        )
    };
    // 渲染稿件编辑器
    render() {
        let that = this;
        return (
            <Editor
                // Editor组件暴露
                ref={(Editor) => {this.Editor = Editor}}
                // 动态参数（传递到子组件中）
                dynamicParams={{
                    editorId:this.state.id,
                    oldId:this.state.storyId,
                    findOldUuid: this.findOldUuid
                }}
                // 流程按钮组件
                editorActBtn={this.renderActBtn()}
                // 稿件基本信息组件
                editorInformation={this.renderInformation()}
                // 稿件栏目设置模块  只有投稿箱的数据才显示右侧信息
                editorRightModule={null}
                // 编辑器加载完毕的回调
                onEditorLoadOver={()=>{
                    window.ueditor.afterSaveDataFun = [];
                    window.ueditor.addAfterSaveDataFun = function(fun){
                        window.ueditor.afterSaveDataFun.push(fun);
                    };
                    that.getStoryById();
                }}
                // 编辑器内容改变的回调
                onEditorContentChange={(content)=>{
                    this.setState({contentText:this.getEditContentText()})
                }}
                // 基本信息展开和关闭的回调
                onInformationStatusCallBack={(status) => {this.setState({informationStatus: status})}}
                // 表单展开状态
                informationStatus={this.state.informationStatus}
                // 右侧展开状态
                publishSettingStatus={false}
                // 编辑器工具栏上的插件配置
                pluginsSpaceConfig={["linkCheck", "securityPlugin","storyResource","storyImport"]}
            />
        )
    }

    /**
     * 获取稿件
     */
    getStoryById = () => {
        let that = this;
        if(!(this.state.id && this.state.id.length>1 && this.state.id != 'null' && this.state.id != 'undefined')){
            return;
        }
        this.request({
            url: '/cm-sites-pms/story/show',
            body: {storyId: this.state.id},
            // contentType:'json',
            callBack: function (res) {
                if (res) {
                    systemBaseEvent.syncPlaybackExec("editorDataChange", res);
                    that.storyData = res;
                    that.setCurrentInformation(res);//回显表单
                    // 重置流程参数
                    that.initActivitiConfig(res);
                    that.setContent(res.content);//回显编辑器内容
                } else {
                    // message.error('稿件加载失败！');
                }
            },
            errorCallBack: function (res) {
                message.error('稿件加载失败！');
            }

        });
    };

    checkForm = (activiti, call) => {
        //获取编辑器内容============================start
        let content = this.getEditContent();
        if(!content) {
            window.loading.hide();
            message.warning("请填写内容！");
            return false
        }
        if(content.indexOf("wordimg.png") !== -1){
            window.loading.hide();
            message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
            return false
        }
        //获取编辑器内容=================end

        let currentInformation = this.getCurrentInformation();//获取基础属性
        if(!currentInformation) {// 基本信息校验（自带）
            window.loading.hide();
            return false
        }
        call&&call()
    };

    /**
     * 稿件保存
     */
    saveStory = (activiti, call) => {
        //获取编辑器内容============================start
        let content = this.getEditContent();
        if(!content) {
            window.loading.hide();
            message.warning("请填写内容！");
            call && call(false);
            return false
        }
        if(content.indexOf("wordimg.png") !== -1){
            window.loading.hide();
            message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
            call&&call(false);
            return false
        }
        //获取编辑器内容=================end

        let currentInformation = this.getCurrentInformation();//获取基础属性
        if(!currentInformation) {// 基本信息校验（自带）
            window.loading.hide();
            call&&call(false);
            return false
        }
        // let {information, dynamicParams={}} = currentInformation;

        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';//稿件id
        // 获取发布设置================start
        let publishData = this.getPublish();
        let {synchronousContribute=[]} = publishData;

        // 获取发布设置=================end
        let that = this;
        window.loading.hide();
        this.LinkCheck.show(content,(res)=>{
            window.loading.show();
            if(res) {
                if(res.content) {
                    this.setContent(res.content);
                }
                if(res.status) {
                    let params = {
                        ...that.storyData,
                        ...currentInformation,
                        "content": base64Encode(removeContentSecurity(res.content || content)),
                        "id": id,
                        "targetIds": synchronousContribute,//投递节点
                        // "title": currentInformation.title,
                        // "attach": currentInformation.attach,// 附件
                        // "titlePic": currentInformation.titlePic,// 主栏目标题图
                        // "variableFields": currentInformation.dynamicParams,//稿件基本信息
                        // // 站群字段
                        // "wbextends": currentInformation.wbextends,
                    };
                    systemBaseEvent.syncExec("editorUpdateData");
                    if(this.publishData?.dbUpdateTime) {
                        // 已经保存过，再次进行保存，需要更新保存时间
                        params.dbUpdateTime = this.publishData.dbUpdateTime
                    }
                    this.request({
                        url: '/cm-sites-pms/story/save',
                        method: 'POST',
                        body: params,
                        contentType: 'json',
                        callBack: async (res) => {
                            if (res) {
                                // 备注，这里必须这样写，稿件保存时不会回显同步投递的参数，但是发布时需要
                                this.publishData = {...params,...res,content: base64Encode(removeContentSecurity(res.content))};
                                this.state.id = res.id;
                                window.loading.hide();
                                systemBaseEvent.syncExec("editorDataChange", res);
                                systemBaseEvent.syncExec("editorIdChange", {editorId: this.state.id});
                                let funs = window.ueditor.afterSaveDataFun;
                                for(let i = 0 ; funs && i < funs.length; i++){
                                    let fun = funs[i];
                                    if(fun instanceof Promise){
                                        await fun(activiti, res, call);
                                    }else{
                                        fun(activiti, res, call);
                                    }
                                }
                                this.securityCheckAsyncCheck({params, activiti, story:res, call});
                                this.updateProcessAndData(this.publishData);
                            } else {
                                message.error('保存失败！');
                                call && call(false);
                            }
                        },
                        errorCallBack: function (e) {
                            call && call(false);
                            message.error('保存失败！');
                        }
                    });
                } else {
                    window.loading.hide();
                    call && call(false);
                    return false
                }
            }
        });
        //   window.ueditor.editRefresh()
    };

    setPublish = (data) => {
    };
    getPublish = (data) => {
        return {}
    }

}